export const getInscricaoCancelamentoInfo = (inscricao, evento) => {
    if (!inscricao || !evento) {
        return {
            canCancel: false,
            refundAllowed: false,
            reason: 'Dados da inscrição ou do evento não disponíveis.'
        };
    }

    const status = String(inscricao.status || '').toLowerCase();
    if (['cancelled', 'refunded', 'rejected'].includes(status)) {
        return {
            canCancel: false,
            refundAllowed: false,
            reason: 'Esta inscrição já está encerrada.'
        };
    }

    const now = new Date();
    const eventDate = new Date(evento.data_evento);
    const inscriptionDate = new Date(inscricao.data_inscricao || now);

    if (Number.isNaN(eventDate.getTime()) || Number.isNaN(inscriptionDate.getTime())) {
        return {
            canCancel: false,
            refundAllowed: false,
            reason: 'A data do evento ou da inscrição não é válida.'
        };
    }

    const hoursUntilEvent = (eventDate - now) / (1000 * 60 * 60);
    const daysSinceInscricao = (now - inscriptionDate) / (1000 * 60 * 60 * 24);

    const withinWindow = hoursUntilEvent >= 24 && daysSinceInscricao <= 7;
    const refundAllowed = withinWindow && Number(inscricao.valor_pago || 0) > 0;

    return {
        canCancel: withinWindow,
        refundAllowed,
        hoursUntilEvent,
        daysSinceInscricao,
        reason: withinWindow
            ? (refundAllowed ? 'Cancelamento permitido com reembolso.' : 'Cancelamento permitido, mas sem valor a reembolsar.')
            : 'O cancelamento só é permitido até 24 horas antes do evento e dentro de 7 dias da inscrição.'
    };
};
